import { PourbackReason } from "@/pages/caster/models/catalogs/pourback-reasons";
import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import { CircularProgress, Grid2 as Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import React, { useState, useEffect } from "react";
import { TablePourbackReasons } from "./components/TablePourbackReasons";
import { getCatalogPourbackReasons } from "./repositories";

const PourbackReasonsPage: React.FC = () => {
	const [pourbackReasons, setPourbackReasons] = useState<PourbackReason[]>([]);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState("");

	const getPourbackReasonsFromAPI = async () => {
		setIsLoading(true);
		const resp = await getCatalogPourbackReasons();
		if (resp.ok) {
			setPourbackReasons(resp.data.tables[0].rows);
		} else {
			setError(resp.message);
		}
		setIsLoading(false);
	};

	useEffect(() => {
		getPourbackReasonsFromAPI();
	}, []);

	const handleRefresh = () => {
		getPourbackReasonsFromAPI();
	};

	if (pourbackReasons) {
		return (
			<>
				<HelmetDexteel title="Pourback Reasons - Configurations" />
				<Grid container justifyContent="center" alignItems="center">
					<Grid size={{ xs: 12, md: 12 }} style={{ margin: 0 }}>
						<Paper
							elevation={0}
							style={{
								width: "100%",
								padding: "15px 20px 10px",
								borderRadius: "0.75rem",
							}}
						>
							<TablePourbackReasons
								pourbackReasons={pourbackReasons}
								isLoading={isLoading}
								onRefresh={handleRefresh}
							/>
						</Paper>
					</Grid>
				</Grid>

				<ErrorModal error={error} onHide={() => setError("")} />
			</>
		);
	}
	return (
		<Grid
			size={{ xs: 12 }}
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "70vh",
			}}
		>
			<CircularProgress />
		</Grid>
	);
};

export default PourbackReasonsPage;
